<template>
  <div id="app">
    <router-view
      :scrollHeight="scrollHeight"
      :key="$route.path"
    ></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
  components: {},
  data() {
    return {
      scrollHeight: 0,
      isShow: false,
    }
  },
  mounted() {
    setTimeout(() => {
      this.setFont()
      // this.isShow = true
    }, 10)
    window.onresize = () => {
      this.setFont()
    }
    window.onscroll = () => {
      this.scrollHeight =
        window.pageYOffset || document.documentElement.scrollTop
    }
  },
  methods: {
    setFont() {
      let w = document.body.clientWidth
      let root = document.getElementsByTagName("html")[0]
      if (w < 1000 && w > 580) {
        root.style.fontSize = (w / 10) * 1.5 + "px"
      } else if (w <= 580) {
        root.style.fontSize = (w / 10) * 2 + "px"
      }
      // console.log(w)
    },
  },
}
</script>

<style lang="scss">
.fade-in{
  transition: all 2s;
  .fade-in{
    animation-delay: 4s;
    transition-delay: 4s;
  }
}
</style>
